import React, { useCallback, useContext, useEffect, useState } from "react";
import logo from "../assets/logo.png";
import Particle from "./Particle";
import Aos from "aos";
import "aos/dist/aos.css";
import { AppContext } from "../utils";
import { useStakingContract, useTokenContract } from "../connectivityAss/hooks";
import { stakingAddress } from "../connectivityAss/environment";
import { formatUnits, parseUnits } from "@ethersproject/units";
import { MaxUint256 } from "@ethersproject/constants";
import { toast } from "react-toastify";
import moment from "moment";
import Loader from "./Loader";
import {
  Box,
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";

export default function Home() {
  const { account, connect, disconnect, signer } = useContext(AppContext);

  const stakingContract = useStakingContract(signer);
  const tokenContract = useTokenContract(signer);

  // const [profit, setProfit] = useState(0);
  const [amount, setAmount] = useState("");
  const [amount1, setAmount1] = useState("");
  const [amount2, setAmount2] = useState("");
  const [stakeDetails, setstakeDetails] = useState([]);
  const [totalStakers, setTotalStakers] = useState(0);
  const [totalStakedTokens, setTotalStakedTokens] = useState(0);
  const [totalWithdrawTokens, setTotalWithdrawTokens] = useState(0);
  const [contractBalance, setContractBalance] = useState(0);
  const [userBalance, setUserBalance] = useState(0);
  const [loading, setLoading] = useState(false);

  const init = useCallback(async () => {
    try {
      // let percentDivide = await stakingContract.percentDivider();
      // let bonus = await stakingContract.Bonus(+planIndex);
      // let percentage = (+bonus / +percentDivide) * amount;

      let decimals = await tokenContract.decimals();
      let contractBalance = await tokenContract.balanceOf(stakingAddress);

      const totalStaker = await stakingContract.totalStakers();
      const totalStaked = await stakingContract.totalStakedToken();
      const totalWithdrawan = await stakingContract.totalWithdrawanToken();

      if (account) {
        setLoading(true);
        let userTotalBalance = await tokenContract.balanceOf(account);
        const { stakeCount } = await stakingContract.Stakers(account);

        if (+stakeCount > 0) {
          let arr = [];
          for (let i = 0; i < +stakeCount; i++) {
            const { amount, withdrawan, unstaked, withdrawtime } =
              await stakingContract.stakersRecord(account, i.toString());
            const obj = {
              time: +withdrawtime,
              amount: +formatUnits(amount.toString(), 18),
              withdrawan: withdrawan,
              unstaked: unstaked,
            };
            arr.push(obj);
          }
          setstakeDetails([...arr]);
        }
        setUserBalance(+formatUnits(userTotalBalance.toString(), +decimals));
        setLoading(false);
      }

      setTotalStakers(+totalStaker);
      setContractBalance(+formatUnits(contractBalance.toString(), +decimals));
      setTotalStakedTokens(+formatUnits(totalStaked.toString(), +decimals));
      setTotalWithdrawTokens(
        +formatUnits(totalWithdrawan.toString(), +decimals)
      );
      // setProfit(+amount + +percentage);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  }, [account, stakingContract, tokenContract]);

  const stakeHandler = async (index) => {
    try {
      if (!account) {
        toast.error("Error! Please connect your wallet.");
      } else {
        setLoading(true);

        let decimals = await tokenContract.decimals();
        let contractAllowance = await tokenContract.allowance(
          account,
          stakingAddress
        );

        const allowance = formatUnits(contractAllowance.toString(), +decimals);
        let amountToStake = amount ? amount : amount1 ? amount1 : amount2;

        if (+allowance < +amountToStake) {
          let approve = await tokenContract.approve(
            stakingAddress,
            MaxUint256.toString()
          );
          await approve.wait();
        }

        const tx = await stakingContract.stake(
          parseUnits(amountToStake.toString(), +decimals),
          index.toString()
        );

        await tx.wait();
        setLoading(false);
        init();
        setAmount("");
        setAmount1("");
        setAmount2("");
        toast.success("Transaction confirmed!!!");
      }
    } catch (e) {
      setLoading(false);
      if (e?.data?.message) {
        toast.error(e?.data?.message);
      } else if (e?.reason) {
        toast.error(e?.reason);
      } else {
        toast.error(e?.message);
      }
    }
  };

  const unStakeHandler = async (index) => {
    try {
      setLoading(true);
      const tx = await stakingContract.unstake(index.toString());
      await tx.wait();
      init();
      toast.success("Unstaked tokens, Successfully!!!");
      setLoading(false);
    } catch (e) {
      setLoading(false);
      if (e?.data?.message) {
        toast.error(e?.data?.message);
      } else if (e?.reason) {
        toast.error(e?.reason);
      } else {
        toast.error(e?.message);
      }
    }
  };
  const withdrawHandler = async (index) => {
    try {
      setLoading(true);
      const tx = await stakingContract.withdraw(index.toString());
      await tx.wait();
      init();
      toast.success("Tokens withdrawan, Successfully!!!");
      setLoading(false);
    } catch (e) {
      setLoading(false);
      if (e?.data?.message) {
        toast.error(e?.data?.message);
      } else if (e?.reason) {
        toast.error(e?.reason);
      } else {
        toast.error(e?.message);
      }
    }
  };

  useEffect(() => {
    init();
  }, [init]);

  useEffect(() => {
    Aos.init({
      duration: 3000,
      once: true,
    });
    Aos.refresh();
  }, []);

  const mainBoxStyle = {
    background: "rgba(44, 43, 43, 0.3)",
    boxShadow: "rgb(255, 255, 255) 0px 3px 8px",
    borderRadius: "5px",
    height: "100%",
    px: 3,
    py: 2,
  };

  return (
    <>
      <Loader loading={loading} />
      <div className="overflow-hidden bg-gray-100 relative z-0 text-white-100 font-spartan">
        {/* menu */}
        <div className=" opacity-1">
          <div className="container mx-auto lg:px-20 px-5 flex items-center justify-between py-3">
            <a href="/">
              <img src={logo} alt="logo" className="w-24" />
            </a>

            {account ? (
              <button
                onClick={() => disconnect()}
                className="py-2 px-8 bg-btn-2 font-semibold text-lg rounded-md transition hover:scale-125"
              >
                {account.slice(0, 4) + "..." + account.slice(-4)}
              </button>
            ) : (
              <button
                onClick={() => connect()}
                className="py-2 px-8 bg-btn-2 font-semibold text-lg rounded-md transition hover:scale-125"
              >
                Connect
              </button>
            )}
          </div>
        </div>

        <div className="container mx-auto lg:px-20 px-5">
          <Particle />

          <div className="flex flex-col items-center justify-center lg:py-20 py-8">
            <div className="grid md:grid-cols-2 grid-cols-1 md:grid-row-2 grid-rows-1 gap-6 items-center justify-center text-center">
              <div className="bg-btn-1 p-6 lg:w-96 w-72 space-y-4">
                <p className="font-semibold text-xl">Total Stakers</p>

                <p className="font-bold text-3xl">{totalStakers}</p>
              </div>

              <div className="bg-btn-2 p-6 lg:w-96 space-y-4">
                <p className="font-semibold text-xl">Total Staked</p>

                <p className="font-bold text-3xl">
                  {parseFloat(totalStakedTokens).toFixed(3)}
                </p>
              </div>

              <div className="bg-btn-2 p-6 lg:w-96 space-y-4">
                <p className="font-semibold text-xl">Total Withdrawn</p>

                <p className="font-bold text-3xl">
                  {parseFloat(totalWithdrawTokens).toFixed(3)}
                </p>
              </div>

              <div className="bg-btn-1 p-6 lg:w-96 space-y-4">
                <p className="font-semibold text-xl">Contract Balance</p>

                <p className="font-bold text-3xl">
                  {parseFloat(contractBalance).toFixed(3)}
                </p>
              </div>
            </div>

            <Box
              my={10}
              display="flex"
              justifyContent="space-around"
              alignItems="center"
              flexDirection={{ xs: "column", md: "row" }}
              gap={3}
            >
              <Box sx={mainBoxStyle}>
                <Box
                  component="img"
                  m="auto"
                  src={logo}
                  alt=""
                  width="128px"
                  height="128px"
                />

                <Stack
                  pt={1}
                  my={1.5}
                  direction="row"
                  justifyContent="space-between"
                >
                  <Typography variant="subtitle1" color="#fff" textAlign="left">
                    APR
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color="#fff"
                    textAlign="right"
                  >
                    60%
                  </Typography>
                </Stack>

                <Stack
                  my={1.5}
                  pb={2}
                  direction="row"
                  justifyContent="space-between"
                >
                  <Typography variant="subtitle1" color="#fff" textAlign="left">
                    Lock Duration
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color="#fff"
                    textAlign="right"
                  >
                    30 Days
                  </Typography>
                </Stack>

                <TextField
                  fullWidth
                  size="small"
                  type="text"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="Enter amount to Stake"
                  sx={{
                    border: "none",
                    background:
                      "linear-gradient(0deg, rgba(245,17,255,1.00) 0.59%, rgba(136, 111, 134, 0.059) 100%)",
                    borderRadius: "5px",
                    boxShadow: "rgb(255, 255, 255) 0px 3px 8px",
                    "& .MuiOutlinedInput-root": {
                      border: "none",
                      "& fieldset": {
                        border: "none",
                      },
                      "&:hover fieldset": {
                        border: "none",
                      },
                      "&.Mui-focused fieldset": {
                        border: "none",
                      },
                    },

                    input: {
                      color: "#fff",
                      fontSize: "15px",
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <Box
                        sx={{
                          fontSize: "14px",
                          color: "#f5f5f5",
                          cursor: "pointer",
                        }}
                        onClick={() => setAmount(userBalance)}
                      >
                        Max
                      </Box>
                    ),
                  }}
                />

                <Button
                  onClick={() => stakeHandler(0)}
                  sx={{
                    width: "100%",
                    paddingY: "4px",
                    fontSize: "17px",
                    color: "#fff",
                    background: "#A817AE",
                    borderRadius: "5px",
                    cursor: "pointer",
                    textTransform: "capitalize",
                    marginTop: "30px",
                    "&:hover": {
                      backgroundColor: "transparent",
                      border: "1px solid #A817AE",
                    },
                  }}
                >
                  stake
                </Button>
              </Box>
              <Box sx={mainBoxStyle}>
                <Box
                  component="img"
                  m="auto"
                  src={logo}
                  alt=""
                  width="128px"
                  height="128px"
                />

                <Stack
                  pt={1}
                  my={1.5}
                  direction="row"
                  justifyContent="space-between"
                >
                  <Typography variant="subtitle1" color="#fff" textAlign="left">
                    APR
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color="#fff"
                    textAlign="right"
                  >
                    146%
                  </Typography>
                </Stack>

                <Stack
                  my={1.5}
                  pb={2}
                  direction="row"
                  justifyContent="space-between"
                >
                  <Typography variant="subtitle1" color="#fff" textAlign="left">
                    Lock Duration
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color="#fff"
                    textAlign="right"
                  >
                    50 Days
                  </Typography>
                </Stack>

                <TextField
                  fullWidth
                  size="small"
                  type="text"
                  value={amount1}
                  onChange={(e) => setAmount1(e.target.value)}
                  placeholder="Enter amount to Stake"
                  sx={{
                    border: "none",
                    background:
                      "linear-gradient(0deg, rgba(245,17,255,1.00) 0.59%, rgba(136, 111, 134, 0.059) 100%)",
                    borderRadius: "5px",
                    boxShadow: "rgb(255, 255, 255) 0px 3px 8px",
                    "& .MuiOutlinedInput-root": {
                      border: "none",
                      "& fieldset": {
                        border: "none",
                      },
                      "&:hover fieldset": {
                        border: "none",
                      },
                      "&.Mui-focused fieldset": {
                        border: "none",
                      },
                    },

                    input: {
                      color: "#fff",
                      fontSize: "15px",
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <Box
                        sx={{
                          fontSize: "14px",
                          color: "#f5f5f5",
                          cursor: "pointer",
                        }}
                        onClick={() => setAmount1(userBalance)}
                      >
                        Max
                      </Box>
                    ),
                  }}
                />

                <Button
                  onClick={() => stakeHandler(1)}
                  sx={{
                    width: "100%",
                    paddingY: "4px",
                    fontSize: "17px",
                    color: "#fff",
                    background: "#A817AE",
                    borderRadius: "5px",
                    cursor: "pointer",
                    textTransform: "capitalize",
                    marginTop: "30px",
                    "&:hover": {
                      backgroundColor: "transparent",
                      border: "1px solid #A817AE",
                    },
                  }}
                >
                  stake
                </Button>
              </Box>
              <Box sx={mainBoxStyle}>
                <Box
                  component="img"
                  m="auto"
                  src={logo}
                  alt=""
                  width="128px"
                  height="128px"
                />

                <Stack
                  pt={1}
                  my={1.5}
                  direction="row"
                  justifyContent="space-between"
                >
                  <Typography variant="subtitle1" color="#fff" textAlign="left">
                    APR
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color="#fff"
                    textAlign="right"
                  >
                    210%
                  </Typography>
                </Stack>

                <Stack
                  my={1.5}
                  pb={2}
                  direction="row"
                  justifyContent="space-between"
                >
                  <Typography variant="subtitle1" color="#fff" textAlign="left">
                    Lock Duration
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color="#fff"
                    textAlign="right"
                  >
                    60 Days
                  </Typography>
                </Stack>

                <TextField
                  fullWidth
                  size="small"
                  type="text"
                  value={amount2}
                  onChange={(e) => setAmount2(e.target.value)}
                  placeholder="Enter amount to Stake"
                  sx={{
                    border: "none",
                    background:
                      "linear-gradient(0deg, rgba(245,17,255,1.00) 0.59%, rgba(136, 111, 134, 0.059) 100%)",
                    borderRadius: "5px",
                    boxShadow: "rgb(255, 255, 255) 0px 3px 8px",
                    "& .MuiOutlinedInput-root": {
                      border: "none",
                      "& fieldset": {
                        border: "none",
                      },
                      "&:hover fieldset": {
                        border: "none",
                      },
                      "&.Mui-focused fieldset": {
                        border: "none",
                      },
                    },

                    input: {
                      color: "#fff",
                      fontSize: "15px",
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <Box
                        sx={{
                          fontSize: "14px",
                          color: "#f5f5f5",
                          cursor: "pointer",
                        }}
                        onClick={() => setAmount2(userBalance)}
                      >
                        Max
                      </Box>
                    ),
                  }}
                />

                <Button
                  onClick={() => stakeHandler(2)}
                  sx={{
                    width: "100%",
                    paddingY: "4px",
                    fontSize: "17px",
                    color: "#fff",
                    background: "#A817AE",
                    borderRadius: "5px",
                    cursor: "pointer",
                    textTransform: "capitalize",
                    marginTop: "30px",
                    "&:hover": {
                      backgroundColor: "transparent",
                      border: "1px solid #A817AE",
                    },
                  }}
                >
                  stake
                </Button>
              </Box>
            </Box>

            <div className="text-center">
              <p className="text-center pb-5 text-3xl font-bold">Your Stakes</p>

              <hr className="line flex mx-auto mb-8"></hr>
            </div>

            <Box mt={7} height="100%" width="100%">
              <TableContainer
                border="none"
                pt={2}
                pb={5}
                sx={{
                  background: "rgba(44, 43, 43, 0.3)",
                  borderRadius: "5px",
                  boxShadow: "rgb(255, 255, 255) 0px 3px 8px",
                }}
              >
                <Table
                  aria-label="simple table"
                  style={{
                    minWidth: "600px",
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        style={{
                          fontSize: "16px",
                          color: "#ffffff",
                        }}
                      >
                        #
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          fontSize: "16px",
                          color: "#ffffff",
                        }}
                      >
                        Staked Amount
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          fontSize: "16px",
                          color: "#ffffff",
                        }}
                      >
                        Withdrawal Time
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          fontSize: "16px",
                          color: "#ffffff",
                        }}
                      >
                        Unstake
                      </TableCell>

                      <TableCell
                        align="center"
                        style={{
                          fontSize: "16px",
                          color: "#ffffff",
                        }}
                      >
                        Claim
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {stakeDetails.length > 0 ? (
                      stakeDetails.map(
                        ({ time, amount, withdrawan, unstaked }, i) => (
                          <TableRow>
                            <TableCell
                              align="center"
                              style={{
                                border: "none",
                                color: "#ffffff",
                              }}
                            >
                              {i + 1}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{
                                border: "none",
                              }}
                            >
                              <Typography
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "600",
                                  color: "#ffffff",
                                }}
                              >
                                {amount}
                              </Typography>
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{
                                border: "none",
                              }}
                            >
                              <Typography
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "600",
                                  color: "#ffffff",
                                }}
                              >
                                {moment.unix(time).format("LLL")}
                              </Typography>
                            </TableCell>

                            <TableCell
                              align="center"
                              style={{
                                border: "none",
                              }}
                            >
                              <Button
                                disabled={
                                  time < moment().format("X") ||
                                  withdrawan ||
                                  unstaked
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  unStakeHandler(i);
                                }}
                                sx={{
                                  width: "80%",
                                  paddingY: "6px",
                                  color: "#fff",
                                  background: "#A817AE",
                                  cursor: "pointer",
                                  textTransform: "capitalize",
                                  borderRadius: "10px",
                                  "&:hover": {
                                    background: "#A817AE",
                                    color: "#fff",
                                  },
                                  "&:disabled": {
                                    background: "#A817AEa1",
                                  },
                                }}
                              >
                                {unstaked ? "Unstaked" : "Unstake"}
                              </Button>
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{
                                border: "none",
                              }}
                            >
                              <Button
                                onClick={() => {
                                  withdrawHandler(i);
                                }}
                                disabled={
                                  time > moment().format("X") ||
                                  withdrawan ||
                                  unstaked
                                    ? true
                                    : false
                                }
                                sx={{
                                  width: "80%",
                                  paddingY: "6px",
                                  color: "#fff",
                                  background: "#A817AE",
                                  cursor: "pointer",
                                  textTransform: "capitalize",
                                  borderRadius: "10px",
                                  "&:hover": {
                                    background: "#A817AE",
                                  },
                                  "&:disabled": {
                                    background: "#A817AEa1",
                                  },
                                }}
                              >
                                {withdrawan ? "Claimed" : "Claim"}
                              </Button>
                            </TableCell>
                          </TableRow>
                        )
                      )
                    ) : (
                      <TableRow>
                        <TableCell
                          // align="center"
                          colSpan={5}
                          style={{
                            border: "none",
                          }}
                        >
                          <Box
                            py={10}
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                          >
                            <Typography
                              sx={{
                                textAlign: "center",
                                fontSize: "27px",
                                fontWeight: "400",
                                marginTop: "10px",
                                color: "#ffffff",
                              }}
                            >
                              You have no staking data
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </div>
        </div>
      </div>
    </>
  );
}
